module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-switch', _vm._g(_vm._b({
    staticClass: "rt-switch"
  }, 'el-switch', _vm.$attrs, false), _vm.$listeners))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34fb1a13"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/switch/rtSwitch.vue
// module id = 2060
// module chunks = 228